/**
 * iter965 — Universal page-size selector. ONE shared control reused on every
 * report/list footer for a consistent look + placement. Options 10/25/50,
 * default 50. Callers must keep the 200 hard cap on the server limit.
 */
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const PAGE_SIZE_OPTIONS = [10, 25, 50];
export const DEFAULT_PAGE_SIZE = 50;

export function PageSizeSelector({ value = DEFAULT_PAGE_SIZE, onChange, label = 'Rows per page', testid = 'page-size-selector' }) {
  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      <span className="text-xs text-muted-foreground">{label}</span>
      <Select value={String(value)} onValueChange={(v) => onChange?.(Number(v))}>
        <SelectTrigger className="h-8 w-[72px] text-xs rounded-md" data-testid={`${testid}-trigger`}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {PAGE_SIZE_OPTIONS.map((n) => (
            <SelectItem key={n} value={String(n)} className="text-xs">{n}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export default PageSizeSelector;
